import { BaseEvent } from 'components/common/BigCalendar/types'

export enum SimulatorTrainingType {
  Instructor,
  Student,
}

export enum SimulatorTrainingSessionType {
  SimulatorEnvironment,
  VirtualClassroom,
}

export type SimulatorTrainingScheduleSessionEvent = BaseEvent & {
  scheduleId?: Guid
}

export enum VendorType {
  Wartsila,
}

export type ListSimulatorTrainingScheduleSessionsModel = {
  trainingId: Guid
  scheduleId?: Guid // API filter sessions by scheduleId
  startDate: DateTime
  endDate: DateTime
}

export type SimulatorTrainingScheduleSession = {
  sessionId: Guid
  scheduleId: Guid
  sessionName: string
  type: SimulatorTrainingSessionType
  startDate: DateTime
  endDate: DateTime
}

export type SimulatorTrainingSessionLink = {
  link: string
  exitUrl: Nullable<string>
}

export type SimulatorTrainingMaintenancePeriod = {
  startDate: DateTime
  endDate: DateTime
}

export type SimulatorTrainingScheduleSessionGroup = {
  date: string // '2021-11-29'
  sessions: SimulatorTrainingScheduleSession[]
}

export type SimulatorTrainingSchedule = {
  scheduleId: Guid
  createdDate: string
  updatedDate: string
  updatedBy: string
  startDate: DateTime
  endDate: DateTime
  timeZone: TimeZone
  maxNumberOfAttempts: Nullable<number>
  utcOffset: string
  title: string
  trainingId: Guid
}

export enum SimulatorTrainingPersonType {
  Instructor,
  Student,
}

export type SimulatorTraining = {
  id: Guid
  name: string
  type: number
  vendor: VendorType
  typeName: string
  traineeWorkplaces: number
  instructorWorkplaces: number
  shutdownTime: number
  turnOnTime: number
}

export enum AssessmentStatus {
  Failed,
  Passed,
}

export type SpecialUser = {
  id: Guid
  firstname: string
  lastname: string
  email: Email
  userName: string
}

// Simulator exercises
export type SimulatorExercise = {
  author: string
  description: string
  duration: number
  maxDuration: number
  id: Guid
  name: string
  publisher: string
  trainingSystem: string
  type: string
}

export type SimulatorExerciseSchedule = {
  scheduleId: Guid
  exerciseId: Guid
  createdDate: DateTime
  updatedDate: DateTime
  updatedBy: string
  startDate: DateTime
  endDate: DateTime
  maxNumberOfAttempts: number
  title: string
}

export enum WartsilaClassroomSessionState {
  Starting,
  Scheduled,
  Running,
  Completed,
  Canceled,
  Failed,
  Stopping,
}

export enum WartsilaExerciseSessionState {
  Starting,
  Running,
  Completed,
  Failed,
  Stopping,
}

export type WartsilaSessionState = WartsilaClassroomSessionState | WartsilaExerciseSessionState

export enum SimulatorType {
  Training,
  Exercise,
}
